import React, { useContext } from 'react';
import Logo from '../logo/Logo';
import { Home, ExitToApp } from '@material-ui/icons';
import SpIconAndTextButton from '../../../components/atoms/SpIconAndTextButton';
import { HeaderContainer, HeaderContainerRow } from './style';
import { useHistory } from 'react-router';
import { logoutUser } from '../../../models/actions/Auth';
import { UserSessionContext } from '../../../App';

const Header = (props) => {
  const history = useHistory();
  const { authData, setAuthData } = useContext(UserSessionContext);
  const logout = async () => {
    const response = await logoutUser({ id: authData.userId }, authData.accessToken);
    if (response) {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('userId');
      setAuthData({ accessToken: null, userId: null });
      return history.replace('/login');
    } else {
      props.snackbarShowErrorMessage(response.error);
    }
  };
  return (
    <HeaderContainerRow>
      <SpIconAndTextButton
        textVariant="headerButton"
        isIconLeft
        style={{ maxWidth: 'fit-content', backgroundColor: 'transparent', paddingRight: 0 }}
        onClick={() => (props?.userAdmin ? history.push('/admin') : history.push('/'))}
      >
        <Home style={{ width: 60, color: '#006E2D', cursor: 'pointer', borderRight: '3px solid #006E2D', paddingRight: 5 }} />
      </SpIconAndTextButton>
      <SpIconAndTextButton
        textVariant="headerButton"
        isIconLeft
        style={{ maxWidth: 'fit-content', backgroundColor: 'transparent' }}
        //onClick={() => props?.userAdmin ? history.push('/admin') : history.push('/'))}
        onClick={() => logout()}
      >
        <ExitToApp style={{ width: 60, color: '#006E2D', cursor: 'pointer' }} />
      </SpIconAndTextButton>
      <Logo style={{ justifyContent: 'flex-end' }} />
    </HeaderContainerRow>
  );
};

export const HeaderBase = (props) => {
  return (
    <HeaderContainer>
      <HeaderContainerRow>
        <Logo />
      </HeaderContainerRow>
    </HeaderContainer>
  );
};

Header.propTypes = {};

export default Header;
